(function () {
  var trigger = document.querySelector('[data-psc-std-ingredients-trigger]');
  var modal = document.querySelector('[data-psc-std-ingredients-modal]');
  var closeBtn = document.querySelector('[data-psc-std-ingredients-close]');
  if (trigger && modal) {
    trigger.addEventListener('click', function () { modal.classList.add('is-open'); });
  }
  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function () { modal.classList.remove('is-open'); });
  }
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.classList.remove('is-open');
    });
  }
})();